exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rpd-value-badge{display:inline-block;margin:2px 4px 2px 0;padding:2px 10px;border:1px solid var(--rpd-line);border-radius:var(--rpd-r-pill);background:var(--rpd-bg-2);color:var(--rpd-navy-700);font-size:13px;font-weight:600;line-height:1.5;white-space:nowrap}html.dark .rpd-value-badge{border-color:var(--rpd-navy-600);background:var(--rpd-navy-800);color:#d6e4f0}", ""]);

// exports
